<template>
  <div v-if="roles">
    <v-toolbar class="primary">
      <v-menu bottom offset-y>
        <v-btn flat slot="activator" dark>
          <v-icon dark>arrow_drop_down</v-icon>
          <v-toolbar-title class="white--text">{{ currentRole }} Permissions</v-toolbar-title>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(role, index) in rolesDropDown" :key="index">
            <v-list-tile-title @click="currentRole = role" style="cursor: pointer">{{ role }} Permissions</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-toolbar class="secondary" v-if="currentRole === 'Admin'">
      <v-toolbar-title class="white--text">The 'Admin' Role Has ALL Privileges and Cannot Be Modified. Select another role.</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-sm>
      <!-- Contact and Project Permissions -->
      <v-layout justify-center>
        <!-- Login To -->
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <!-- Contact -->
              <v-card class="mb-3 pl-2">
                <v-list>
                  <span class="title"><v-icon class="mr-3">people</v-icon>Contacts</span>
                </v-list>
                <v-list>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.contacts.create" @change="updateRole('contacts', 'create', roles.contacts.create)" row>
                    <span class="pr-3">Create Contacts</span>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.contacts.view" @change="updateRole('contacts', 'view', roles.contacts.view)" row>
                    <span class="pr-3">View Contacts</span>
                    <v-radio :label="selections.all" value="all"></v-radio>
                    <!-- <v-radio :label="selections.created" value="created"></v-radio> -->
                    <v-radio :label="selections.assigned" value="assigned"></v-radio>
                    <v-radio :label="selections.none" value="none"></v-radio>
                  </v-radio-group>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.contacts.edit" @change="updateRole('contacts', 'edit', roles.contacts.edit)" row>
                    <span class="pr-3">Edit Contacts</span>
                    <v-radio :label="selections.all" value="all"></v-radio>
                    <!-- <v-radio :label="selections.created" value="created"></v-radio> -->
                    <v-radio :label="selections.assigned" value="assigned"></v-radio>
                    <v-radio :label="selections.none" value="none"></v-radio>
                  </v-radio-group>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.contacts.delete" @change="updateRole('contacts', 'delete', roles.contacts.delete)" row>
                    <span class="pr-3">Delete Contacts</span>
                    <v-radio :label="selections.all" value="all"></v-radio>
                    <!-- <v-radio :label="selections.created" value="created"></v-radio> -->
                    <v-radio :label="selections.assigned" value="assigned"></v-radio>
                    <v-radio :label="selections.none" value="none"></v-radio>
                  </v-radio-group>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6>
              <!-- Projects -->
              <v-card class="mb-3 pl-2">
                <v-list>
                  <span class="title"><v-icon class="mr-3">people</v-icon>Projects</span>
                </v-list>
                <v-list>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.projects.create" @change="updateRole('projects', 'create', roles.projects.create)" row>
                    <span class="pr-3">Create Projects</span>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.projects.view" @change="updateRole('projects', 'view', roles.projects.view)" row>
                    <span class="pr-3">View Projects</span>
                    <v-radio :label="selections.all" value="all"></v-radio>
                    <!-- <v-radio :label="selections.created" value="created"></v-radio> -->
                    <v-radio :label="selections.assigned" value="assigned"></v-radio>
                    <v-radio :label="selections.none" value="none"></v-radio>
                  </v-radio-group>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.projects.edit" @change="updateRole('projects', 'edit', roles.projects.edit)" row>
                    <span class="pr-3">Edit Projects</span>
                    <v-radio :label="selections.all" value="all"></v-radio>
                    <!-- <v-radio :label="selections.created" value="created"></v-radio> -->
                    <v-radio :label="selections.assigned" value="assigned"></v-radio>
                    <v-radio :label="selections.none" value="none"></v-radio>
                  </v-radio-group>
                  <v-radio-group :disabled="currentRole === 'Admin'" v-model="roles.projects.delete" @change="updateRole('projects', 'delete', roles.projects.delete)" row>
                    <span class="pr-3">Delete Projects</span>
                    <v-radio :label="selections.all" value="all"></v-radio>
                    <!-- <v-radio :label="selections.created" value="created"></v-radio> -->
                    <v-radio :label="selections.assigned" value="assigned"></v-radio>
                    <v-radio :label="selections.none" value="none"></v-radio>
                  </v-radio-group>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
      </v-layout>
      <!-- Other Permissions -->
      <v-layout>
        <span class="title"><v-icon class="mr-3">people</v-icon>Other Permissions</span>
      </v-layout>
      <v-layout mt-2 justify-center row wrap>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.manageUsers" @change="updateRole('others', 'manageUsers', roles.others.manageUsers)" :label="'Manage Users'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.manageVenders" @change="updateRole('others', 'manageVenders', roles.others.manageVenders)" :label="'Manage Vendors'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.manageBuilders" @change="updateRole('others', 'manageBuilders', roles.others.manageBuilders)" :label="'Manage Builders'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.manageTaskTemplates" @change="updateRole('others', 'manageTaskTemplates', roles.others.manageTaskTemplates)" :label="'Manage Task Templates'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.showAllLeads" @change="updateRole('others', 'showAllLeads', roles.others.showAllLeads)" :label="'Show All Leads'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.uploadPoolPrints" @change="updateRole('others', 'uploadPoolPrints', roles.others.uploadPoolPrints)" :label="'Upload Pool Prints'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.deletePoolPrints" @change="updateRole('others', 'deletePoolPrints', roles.others.deletePoolPrints)" :label="'Delete Pool Prints'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.fastTaskDeletion" @change="updateRole('others', 'fastTaskDeletion', roles.others.fastTaskDeletion)" :label="'Enable Fast Deletion of Tasks'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.sendProjectToConstruction" @change="updateRole('others', 'sendProjectToConstruction', roles.others.sendProjectToConstruction)" :label="'Send Project to Construction'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.completeProject" @change="updateRole('others', 'completeProject', roles.others.completeProject)" :label="'Complete Projects'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.sendProjectToLeads" @change="updateRole('others', 'sendProjectToLeads', roles.others.sendProjectToLeads)" :label="'Send Project Back To Leads'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.createCompletedProjects" @change="updateRole('others', 'createCompletedProjects', roles.others.createCompletedProjects)" :label="'Create Completed Projects'"></v-checkbox>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.others.deleteLeads" @change="updateRole('others', 'deleteLeads', roles.others.deleteLeads)" :label="'Can Delete Leads'"></v-checkbox>
      </v-layout>
      <!-- DropDowns -->
      <v-layout>
        <span class="title"><v-icon class="mr-3">people</v-icon>Modify Dropdown Permissions</span>
      </v-layout>
      <v-layout mt-2 justify-center row wrap>
        <v-checkbox :disabled="currentRole === 'Admin'" class="mr-3" v-model="roles.dropdowns.referralSources" @change="updateRole('dropdowns', 'referralSources', roles.dropdowns.referralSources)" :label="'Referral Sources'"></v-checkbox>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      values: {ContactsCreate: 'true', ContactsView: 'all', ContactsEdit: null, ContactsDelete: true, ProjectsCreate: null, ProjectsView: null, ProjectsEdit: null, ProjectsDelete: null},
      contacts: {create: null, delete: {all: true, assigned: false, created: false, none: false}},
      selections: {all: 'All', created: 'Created', assigned: 'Assigned', none: 'None'},
      loginUrl: '/home',
      loginOptions: [{text: 'Leads', value: '/leads'}, {text: 'Pre-Construction', value: '/projects/Pre-Construction'},
                    {text: 'Construction', value: '/projects/Construction'}, {text: 'Pre-Construction Summary', value: '/reports/projectsummary/Pre-Construction'},
                    {text: 'Construction Summary', value: '/reports/projectsummary/Construction'}],
      projectsView: true,
      projectsEdit: true,
      currentRole: 'Admin'
    }
  },
  created () {
    this.$store.dispatch('getRoles', 'Admin')
  },
  watch: {
    currentRole () {
      this.$store.dispatch('getRoles', this.currentRole)
    }
  },
  computed: {
    roles () {
      const roles = this.$store.getters.roles
      const contacts = {create: roles.contacts.create, view: roles.contacts.view.all ? 'all' : roles.contacts.view.assigned ? 'assigned' : roles.contacts.view.created ? 'created' : 'none', edit: roles.contacts.edit.all ? 'all' : roles.contacts.edit.assigned ? 'assigned' : roles.contacts.edit.created ? 'created' : 'none', delete: roles.contacts.delete.all ? 'all' : roles.contacts.delete.assigned ? 'assigned' : roles.contacts.delete.created ? 'created' : 'none'}
      const projects = {create: roles.projects.create, view: roles.projects.view.all ? 'all' : roles.projects.view.assigned ? 'assigned' : roles.projects.view.created ? 'created' : 'None', edit: roles.projects.edit.all ? 'all' : roles.projects.edit.assigned ? 'assigned' : roles.projects.edit.created ? 'created' : 'none', delete: roles.projects.delete.all ? 'all' : roles.projects.delete.assigned ? 'assigned' : roles.projects.delete.created ? 'created' : 'none'}
      const others = {manageUsers: roles.others.manageUsers, manageVenders: roles.others.manageVenders, manageBuilders: roles.others.manageBuilders, manageTaskTemplates: roles.others.manageTaskTemplates, showAllLeads: roles.others.showAllLeads, uploadPoolPrints: roles.others.uploadPoolPrints, deletePoolPrints: roles.others.deletePoolPrints, fastTaskDeletion: roles.others.fastTaskDeletion, sendProjectToConstruction: roles.others.sendProjectToConstruction, completeProject: roles.others.completeProject, sendProjectToLeads: roles.others.sendProjectToLeads, createCompletedProjects: roles.others.createCompletedProjects, deleteLeads: roles.others.deleteLeads}
      const dropdowns = {referralSources: roles.dropdowns.referralSources}
      const combined = {contacts, projects, others, dropdowns}
      return combined
    },
    rolesDropDown () {
      return this.$store.getters.rolesDropDown
    }
  },
  methods: {
    updateRole (role, type, value) { // contacts, create, false
      const update = role + '.' + type
      this.$store.dispatch('updateRole', {doc: this.currentRole, role: role, type: type, update: update, value: value})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Roles.vue